import { useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Accordion, AccordionDetails, AccordionSummary, Box, Container, Stack, Typography } from '@mui/material';
import PageBanner from '../../components/Common/PageBanner';
import SectionHeading from '../../components/Common/SectionHeading';
import { faqs, pageContent } from '../../data/siteData';

function FAQPage() {
  const content = pageContent.faqPage;
  const [expanded, setExpanded] = useState('panel-0');

  return (
    <Box>
      <PageBanner {...content.banner} />
      <Container maxWidth="md" sx={{ py: { xs: 8, md: 10 } }}>
        <SectionHeading
          eyebrow={content.heading.eyebrow}
          title={content.heading.title}
          subtitle={content.heading.subtitle}
        />
        <Stack spacing={2}>
          {faqs.map((faq, index) => {
            const panel = `panel-${index}`;
            const open = expanded === panel;
            return (
              <Accordion key={faq.question} expanded={open} onChange={(_, isExpanded) => setExpanded(isExpanded ? panel : false)} elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMoreRoundedIcon sx={{ color: '#c9a84c' }} />}
                  sx={{
                    bgcolor: open ? '#4a0e8f' : '#fffdfa',
                    color: open ? '#ffffff' : '#1a0533',
                  }}
                >
                  <Typography sx={{ fontWeight: 800 }}>{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ color: 'text.secondary', lineHeight: 1.8 }}>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Stack>
      </Container>
    </Box>
  );
}

export default FAQPage;
